import {Injectable} from '@angular/core';
import {InfoService} from '../section-service.class';
import {Service} from '../../common/service.class';
import {Observable} from 'rxjs';
import {PlaceInfo} from './place-info.model';

/**
 * Created by Rodrigo Quesada on 28/02/17.
 */
@Injectable()
export class PlaceInfoService extends InfoService {

    constructor(svcm: Service.InjectedMembers) {
        super(svcm, 'place');
    }

    getPlaces(): Observable<Array<PlaceInfo>> {
        return this.getList(PlaceInfo);
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/domain/model/info/place/place-info.service.ts